export default __webpack_public_path__ + "static/media/alert.8043e7a8.svg";